import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  content: {
    padding: theme.spacing[5],
    paddingTop: theme.spacing[1],
    paddingBottom: theme.spacing[8],
    gap: theme.spacing[3],
  },
  title: {
    marginBottom: theme.spacing[5],
  },
  barberInfo: {
    marginBottom: theme.spacing[5],
  },
  confirmButton: {
    marginTop: theme.spacing[5],
  },
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing[3],
  },
  slotButton: {
    paddingVertical: theme.spacing[5],
    borderRadius: theme.borderRadius.m,
    borderWidth: 1,
    borderColor: colors.borderPrimary,
    alignItems: 'center',
    justifyContent: 'center',
    width: '31%',
    flexGrow: 0,
  },
  slotButtonSelected: {
    backgroundColor: colors.backgroundBrand,
    borderColor: colors.backgroundBrand,
  },
}));
